import React, { useState } from "react";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import filter from "lodash/filter";
import reject from "lodash/reject";
import MaterialModal from "../MaterialModal";
import { hideModal } from "../../../actions/actionCreators";
import { startNewLayout } from "../../../actions/exportLayoutActions2";
import withModal from "../withModal";

import TextField from "@material-ui/core/TextField";

const CreateModal = ({ isOpen }) => {
    const dispatch = useDispatch();
    const [layoutName, setLayoutName] = useState("");
    const [errors, setErrors] = useState("");
    const [hasError, setHasError] = useState(false);
    const layouts = useSelector(state => state.layouts);

    const hide = () => dispatch(hideModal("LAYOUT_CREATE"));

    const create = () => {
        if (layoutName != "") {
            dispatch(startNewLayout(layoutName));
            clear();
        } else {
            setErrors("Name is required.");
            setHasError(true);
        }
    };

    const clear = () => {
        setLayoutName("");
        setErrors("");
        setHasError(false);
        hide();
    };

    const handleNameChange = val => {
        let nameError = null;
        setLayoutName(val);
        let myLayouts = filter(layouts);
        //ensure we also reject recently deleted layouts
        myLayouts = reject(myLayouts, { LayoutID: null });

        const hasMyLayoutName = myLayouts.map(x => x.LayoutName).includes(val);

        // Check for blank name
        if (val.trim() == "") {
            nameError = "Name is required";
        }

        // Check for duplicate name on save
        if (hasMyLayoutName) {
            nameError = "This layout name is already used.";
        }

        if (nameError) {
            setHasError(true);
            setErrors(nameError);
        } else {
            setHasError(false);
            setErrors("");
        }

        return nameError == null;
    };

    return (
        <MaterialModal
            id="create-layout"
            isOpen={isOpen}
            title="New Layout"
            primaryButtonText="Create"
            onClose={clear}
            onPrimaryButtonRequest={create}
            showPrimaryButton={true}
            isPrimaryButtonDisabled={hasError}
        >
            <div style={{ display: "flex", flexDirection: "column" }}>
                <TextField
                    error={hasError}
                    style={{ minWidth: "100px" }}
                    inputProps={{ style: { fontSize: "15px" } }}
                    label="Name"
                    type="text"
                    helperText={errors}
                    value={layoutName}
                    required
                    onChange={e => {
                        handleNameChange(e.target.value);
                    }}
                />
            </div>
        </MaterialModal>
    );
};
CreateModal.propTypes = {
    isOpen: PropTypes.bool,
    // Injected from Redux (ActionCreators)
    hideModal: PropTypes.func,
};

export default withModal(CreateModal, "LAYOUT_CREATE");
